import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../user/services/auth/auth.service';
import {Router} from '@angular/router';
import {CurrentUserService} from '../../../user/services/current-user/current-user.service';
import {UserModel} from '../../../user/models/UserModel';
import {AirportService} from '../../../airport/services/airport/airport.service';

export interface MenuItem {
  label: string;
  url?: string;
  active?: boolean;
  wildcard?: boolean;
  permissions?: string[];
  children?: MenuItem[]
}

const menuItemDefinitions: MenuItem[] = [
  {
    label: 'Dashboard',
    url: '/dashboard',
    permissions: ['view-dashboard']
  },
  {
    label: 'Airports',
    url: '/dashboard/airports',
    wildcard: true,
    permissions: ['view-airports']
  },
  {
    label: 'Airlines',
    url: '/dashboard/airlines',
    wildcard: true,
    permissions: ['view-airlines']
  },
  {
    label: 'Regions',
    url: '/dashboard/regions',
    wildcard: true,
    permissions: ['view-region']
  },
  {
    label: 'Users',
    url: '/dashboard/users',
    wildcard: true,
    permissions: ['view-users']
  },
  {
    label: 'Reports',
    children: [
      {
        label: 'Rollup Reports',
        url: '/dashboard/reports',
        permissions: ['view-reports']
      },
      {
        label: 'Service Report',
        url: '/dashboard/servicereport',
        permissions: ['edit-reports']
      },
      {
        label: 'Billing Report',
        url: '/dashboard/billing-report',
        permissions: ['edit-reports']
      }
    ]
  },
  {
    label: 'Settings',
    children: [
      {
        label: 'Default Contract',
        url: '/dashboard/contract',
        wildcard: true,
        permissions: ['edit-field-groups']
      },
      {
        label: 'Field Groups & Services',
        url: '/dashboard/field-groups',
        wildcard: true,
        permissions: ['edit-field-groups']
      },
      {
        label: 'Global Services Schedule',
        url: '/dashboard/global-services-schedule',
        wildcard: true,
        permissions: ['view-global-schedule']
      },
    ]
  }
];



@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {


  public menuItems: MenuItem[];

  public user: UserModel;

  constructor(public auth: AuthService,
              public router: Router,
              private currentUserService: CurrentUserService,
              private airportService: AirportService) {
  }

  ngOnInit() {
    this.currentUserService.getCurrentUser().subscribe(
      user => {
        this.user = user;
        this.menuItems = this.constructMenu(menuItemDefinitions)
          .map(item => {
            this.applyActiveToMenuItem(item);
            if (this.user.can('view-own-airport')) {
                if (item.label === 'Airports') {
                    item.url = '/dashboard/airports/' + this.user.airport_id;
                    item.label = '';
                    this.airportService.getAirport(this.user.airport_id).then((response) => item.label = response.name)
                }
            }
            (item.children || []).forEach(child => this.applyActiveToMenuItem(child));
            return item;
          });
      }
    );
  }

  constructMenu(items: MenuItem[]): MenuItem[] {
    return items.filter((item: MenuItem) => {
      if (item.permissions === undefined)
        return true;
      return this.user.can(item.permissions)
    });
  }

  applyActiveToMenuItem(item: MenuItem) {
    if (item.wildcard && this.router.url.indexOf(item.url) !== -1)
      item.active = true;
    else if (item.url === this.router.url)
      item.active = true;
  }

  shouldDisplayParent(item: MenuItem) {

    if (item.children === undefined)
      return false;
    return item.children.length !== 0;
  }

  shouldDisplayMenuItem(item: MenuItem) {
    return item.children === undefined;
  }

  resetActive() {
    this.menuItems.forEach((currentItem) => {
      currentItem.active = false;
      (currentItem.children || []).forEach(child => child.active = false)
    });
  }

  onItemClick(item, index) {
    console.log(item, index);
    this.router.navigate([item.url]);
    this.resetActive();
    this.menuItems[index].active = true;
  }

  onClickSubItem(parentIndex, item, index) {
    console.log(parentIndex, item, index);
    this.router.navigate([item.url]);
    this.resetActive();
    this.menuItems[parentIndex].children[index].active = true;
  }
}




// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/layout/components/main-menu/main-menu.component.ts